import gql from "graphql-tag";
import * as React from "react";

import type {AsyncApolloMutationResult, MutateFn} from "@khan/data-gql-apollo";
import {gqlOp, type GqlOperation} from "@khan/data-gql-core";

import ApolloMutation from "#data-access/gql/apollo-mutation.tsx";

const JOIN_STUDENT_MUTATION: GqlOperation<Data, Variables> = gqlOp(gql`
    mutation joinStudentMutation($classCode: String!) {
        joinStudent(classCode: $classCode) {
            errors
            error {
                code
                signupCode
                classroomName
            }
        }
    }
`);
export const JOIN_STUDENT_MUTATION_FOR_TESTS = JOIN_STUDENT_MUTATION;

type Data = {
    joinStudent: {
        errors: string;
        error: {
            code: string;
            signupCode: string;
            classroomName: string;
        };
    };
};

type Variables = {
    classCode: string;
};

type Props = {
    classCode: string;
    onCompleted: (errors?: string | null | undefined) => unknown;
    children: (
        mutate: MutateFn<Data, Variables>,
        result: AsyncApolloMutationResult<Data>,
    ) => React.ReactNode;
};

/**
 * JoinStudentMutation is a Mutation for joining a class as a student, by
 * class code.
 */
export default class JoinStudentMutation extends React.Component<Props> {
    render(): React.ReactNode {
        const {classCode, children, onCompleted} = this.props;

        const variables: Variables = {classCode};

        return (
            <ApolloMutation
                mutation={JOIN_STUDENT_MUTATION}
                variables={variables}
                onCompleted={(data) => {
                    onCompleted(data?.joinStudent.errors);
                }}
            >
                {children}
            </ApolloMutation>
        );
    }
}
